<script>
import Layout from '@layouts/simple'
import SystemSettingsList from '@utils/system-settings-list'

export default {
  metaInfo: {
    title: 'SystemSettingsList',
    meta: [{ name: 'description', content: 'System Settings' }],
  },
  name: 'SystemSettingsList',
  components: { Layout },
  data() {
    return {
      list: SystemSettingsList,
    }
  },
}
</script>

<template>
  <Layout>
    <v-container fluid>
      <v-list>
        <v-list-tile
          v-for="item in list"
          :key="item.id"
          :to="`/systemSettings/${item.name}`"
        >{{ $t(`dictionaries__${item.name}`) }}</v-list-tile>
      </v-list>
    </v-container>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
